__turbopack_context__.v({
  "btn": "OqgCDG_btn",
  "btnBlocked": "OqgCDG_btnBlocked",
  "btnUnblocked": "OqgCDG_btnUnblocked",
  "content": "OqgCDG_content",
  "description": "OqgCDG_description",
  "disabled": "OqgCDG_disabled",
  "imageWrapper": "OqgCDG_imageWrapper",
  "lockIconWrapper": "OqgCDG_lockIconWrapper",
  "soldOut": "OqgCDG_soldOut",
  "soldOutStamp": "OqgCDG_soldOutStamp",
  "wrapper": "OqgCDG_wrapper",
});
